import {all, take} from 'redux-saga/effects'
import { REHYDRATE } from 'redux-persist/lib/constants';

import login from './login';
import checkSession from './checkSession';
export default function* rootSaga() {
    yield take(REHYDRATE);
    yield all([
        login(),
        checkSession()
    ]);
}
